export type RcEnvironment = 'local' | 'dev' | 'staging' | 'prod';
type EnvironmentToHostnamesConfig = Record<RcEnvironment, string[]>;

export const envToHostnamesConfig: EnvironmentToHostnamesConfig = {
  local: ['localhost', '127.0.0.1'],
  dev: ['recourse-cockpit.turdev.aws.platform.porsche-preview.cloud'],
  staging: ['recourse-cockpit.turstaging.aws.platform.porsche-preview.cloud'],
  prod: ['recourse-cockpit.turprod.aws.platform.porsche.cloud'],
};

interface HostnameToEnvironmentMap {
  [hostname: string]: RcEnvironment;
}

export function getHostname(): string {
  return globalThis.location.hostname;
}

/**
 * Returns `null` for an unmapped hostname rather than throwing: this runs at module scope in
 * `main.ts` (before `bootstrapApplication`), where a throw leaves a blank page with nothing but a
 * raw console error. The caller raises it inside the app initializer instead, where `LoggerService`
 * and Angular's error handling exist. See TARE-18657.
 */
export function determineConfigEnvironment(hostname: string): RcEnvironment | null {
  const convertEnvToHostnameConfigToMap = (config: EnvironmentToHostnamesConfig): HostnameToEnvironmentMap =>
    Object.entries(config).reduce((hostToEnvMap, [environment, hosts]) => {
      hosts.forEach(host => {
        hostToEnvMap[host] = environment as RcEnvironment;
      });
      return hostToEnvMap;
    }, {} as HostnameToEnvironmentMap);

  const hostnameToEnvironmentMap: HostnameToEnvironmentMap = convertEnvToHostnameConfigToMap(envToHostnamesConfig);
  return hostnameToEnvironmentMap[hostname] ?? null;
}
